import UserModel, { RawNewUserInfo, RawUserInfo } from "@/models/user";

export type UserInfo = RawUserInfo;
export type NewUserInfo = RawNewUserInfo;

export default class UserController {
  public static getUserRoles(): string[] {
    return ["admin", "moderator"];
  }

  public static getUsers(): Promise<UserInfo[]> {
    return UserModel.getUsers();
  }

  public static createUser(userInfo: NewUserInfo) {
    return UserModel.createUser(userInfo);
  }

  public static deleteUser(email: string) {
    return UserModel.deleteUser(email);
  }

  public static setUserRole(email: string, role: string) {
    return UserModel.setUserRole(email, role);
  }
}
